import * as React from 'react';
import Box from '@mui/material/Box';

const FixedContainer = ({children}) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        backgroundColor: '#fff',
      }}
    >
      {children}
    </Box>
  );
}

export default FixedContainer;